import axios from 'axios'
import store from '@/store'

const http = axios.create({ baseURL: process.env.VUE_APP_API_BASE || '/api/qzctech/pet', timeout: 20000 })
http.interceptors.request.use((config) => {
  if (store.state.token) config.headers.Authorization = `Bearer ${store.state.token}`
  return config
})
http.interceptors.response.use(
  (response) => {
    const value = response.data
    if (value && value.code !== 200) return Promise.reject(new Error(value.message || '操作失败'))
    return value
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit('clearAuth')
      const base = (process.env.BASE_URL || '/').replace(/\/$/, '')
      const loginPath = `${base}/login`
      if (!window.location.pathname.endsWith('/login')) {
        window.location.href = loginPath
      }
    }
    return Promise.reject(error)
  }
)

export default {
  login: (data) => http.post('/auth/login', data),
  me: () => http.get('/auth/me'),
  dashboard: (storeId) => http.get('/admin/dashboard', { params: { storeId } }),
  stores: (params) => http.get('/admin/stores', { params }),
  saveStore: (data) => http.post('/admin/stores', data),
  products: (params) => http.get('/admin/products', { params }),
  productDetail: (id, storeId) => http.get(`/admin/products/${id}`, { params: { storeId } }),
  saveProduct: (data) => http.post('/admin/products', data),
  productCategories: () => http.get('/admin/product-categories'),
  saveProductCategory: (data) => http.post('/admin/product-categories', data),
  banners: (params) => http.get('/admin/marketing/banners', { params }),
  saveBanner: (data) => http.post('/admin/marketing/banners', data),
  quickEntries: () => http.get('/admin/marketing/quick-entries'),
  saveQuickEntry: (data) => http.post('/admin/marketing/quick-entries', data),
  rechargePlans: () => http.get('/admin/marketing/recharge-plans'),
  saveRechargePlan: (data) => http.post('/admin/marketing/recharge-plans', data),
  pointProducts: () => http.get('/admin/marketing/point-products'),
  savePointProduct: (data) => http.post('/admin/marketing/point-products', data),
  legalDocuments: () => http.get('/admin/legal-documents'),
  saveLegalDocument: (type, data) => http.post(`/admin/legal-documents/${type}`, data),
  coupons: () => http.get('/admin/marketing/coupons'),
  saveCoupon: (data) => http.post('/admin/marketing/coupons', data),
  reviews: (params) => http.get('/admin/reviews', { params }),
  handleReview: (id, data) => http.post(`/admin/reviews/${id}`, data),
  notifications: (params) => http.get('/admin/notifications', { params }),
  sendNotification: (data) => http.post('/admin/notifications', data),
  uploadFile: (file) => {
    const data = new FormData()
    data.append('file', file)
    return http.post('/admin/files', data, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  inventorySummary: (params) => http.get('/admin/inventory/summary', { params }),
  suppliers: (params) => http.get('/admin/inventory/suppliers', { params }),
  saveSupplier: (data) => http.post('/admin/inventory/suppliers', data),
  purchases: (params) => http.get('/admin/inventory/purchases', { params }),
  createPurchase: (data) => http.post('/admin/inventory/purchases', data),
  receivePurchase: (id) => http.post(`/admin/inventory/purchases/${id}/receive`),
  inventorySales: (params) => http.get('/admin/inventory/sales', { params }),
  createInventorySale: (data) => http.post('/admin/inventory/sales', data),
  stockMovements: (params) => http.get('/admin/inventory/movements', { params }),
  adjustStock: (data) => http.post('/admin/inventory/adjustments', data),
  services: (params) => http.get('/admin/services', { params }),
  saveService: (data) => http.post('/admin/services', data),
  serviceCategories: () => http.get('/admin/service-categories'),
  saveServiceCategory: (data) => http.post('/admin/service-categories', data),
  deleteServiceCategory: (id) => http.post(`/admin/service-categories/delete/${id}`),
  aiImageStyles: () => http.get('/admin/ai-image/styles'),
  saveAiImageStyle: (data) => http.post('/admin/ai-image/styles', data),
  deleteAiImageStyle: (id) => http.post(`/admin/ai-image/styles/delete/${id}`),
  aiImageOptions: (params) => http.get('/admin/ai-image/options', { params }),
  saveAiImageOption: (data) => http.post('/admin/ai-image/options', data),
  deleteAiImageOption: (id) => http.post(`/admin/ai-image/options/delete/${id}`),
  orders: (params) => http.get('/admin/orders', { params }),
  orderStatus: (id, status) => http.post(`/admin/orders/${id}/status`, { status }),
  shipOrder: (id, data) => http.post(`/admin/orders/${id}/ship`, data),
  afterSales: (params) => http.get('/admin/after-sales', { params }),
  handleAfterSale: (id, data) => http.post(`/admin/after-sales/${id}/handle`, data),
  appointments: (params) => http.get('/admin/appointments', { params }),
  appointmentStatus: (id, status) => http.post(`/admin/appointments/${id}/status`, { status }),
  customers: (params) => http.get('/admin/customers', { params }),
  customerPets: (id, params) => http.get(`/admin/customers/${id}/pets`, { params }),
  recharges: (params) => http.get('/admin/recharges', { params }),
  staff: (params) => http.get('/admin/staff', { params }),
  saveStaff: (data) => http.post('/admin/staff', data),
  boardingRoomTypes: (params) => http.get('/admin/boarding/room-types', { params }),
  saveBoardingRoomType: (data) => http.post('/admin/boarding/room-types', data),
  boardingBookings: (params) => http.get('/admin/boarding/bookings', { params }),
  boardingDetail: (id) => http.get(`/admin/boarding/bookings/${id}`),
  boardingStatus: (id, data) => http.post(`/admin/boarding/bookings/${id}/status`, data),
  addBoardingLog: (id, data) => http.post(`/admin/boarding/bookings/${id}/logs`, data),
}
